import Vue from 'vue'

import App from './App.vue';
import router from '@/router';
import Cookies from "js-cookie";
import i18n from './utils/lang.js';

Vue.prototype.$cookie = Cookies;
Vue.config.productionTip = false;
import 'swiper/swiper-bundle.min.css';

new Vue({
	i18n,
	router,
	render: h => h(App),
}).$mount('#app')
